import {tableColResize} from '@/tools/table-drag';
let cacheSize = parseInt(localStorage.getItem('pageSize'))
const tableData = {
    tableSet:{
        loading:false,
        isFullscreen:false,
        selection: 'multiple',
        showSelection:true,
        selected: [],
        data: [
            {BSTKD_E:'001',bjdh:'bjdh',khcgddcjrq:'khcgddcjrq'}
        ],
        count: 0,
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 3, page: 1, query: {} },
        tools: {
            show_toolbar: true,
            btns: [
                { index: 0, name: ['订单配置'], icon: 'fas fa-file-alt', check_lines: 0, on_click: [], sign: 'orderConfig', },
                { index: 1, name: ['发送订单'], icon: 'fas fa-paper-plane', check_lines: 0, on_click: [], sign: 'sendOrder', },
            ]
        },
        tableName:'send-order-list',
        columns: [
            {name: 'BSTKD_E', align: 'left', label: '采购订单号', field: 'BSTKD_E', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'bjdh', align: 'left', label: '报价单号', field: 'bjdh', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'khcgddcjrq', align: 'left', label: '客户采购订单创建日期', field: 'khcgddcjrq', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'dhr', align: 'left', label: '订货人', field: 'dhr', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'shr', align: 'left', label: '收货人', field: 'shr', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'fbsj', align: 'left', label: '发货状态', field: 'fbsj', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'fssj', align: 'left', label: '发送时间', field: 'fssj', sortable: true,format: (val) => `${val ? val : ''}`},
        ]
    },
    entryTableSet:{
        edit:true,
        loading:false,
        isFullscreen:false,
        selection: 'multiple',
        showSelection:true,
        selected: [],
        data: [
            {hh:'001',khcgddhh:'khcgddhh',dhh:'dhh',sl:100,shr:'shr'}
        ],
        count: 0,
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 3, page: 1, query: {} },
        tools: {
            show_toolbar: true,
        },
        columns: [
            {name: 'hh', align: 'left', label: '行号', field: 'hh', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'khcgddhh', align: 'left', label: '客户采购订单行号', field: 'khcgddhh', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'dhh', align: 'left', label: '订货号', field: 'dhh', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'sl', align: 'right', label: '数量', field: 'sl', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'shr', align: 'left', label: '客户期望交货日期', field: 'shr', sortable: true,format: (val) => `${val ? val : ''}`},
        ]
    },
};
const state = () => ({
    sendOrder: Object.assign({}, tableData),
})
const getters = {
    getTableSet: state => state.sendOrder.tableSet,
    getEntryTableSet: state => state.sendOrder.entryTableSet,
}
const mutations ={
    setList(state, data) {
        state.sendOrder.tableSet.pagination.rowsNumber = data.count
        state.sendOrder.tableSet.data = data.data
    },
    ['refreshTableHeight'](state, data) {
        // state.sendOrder.tableSet.maxHeight = (data -55) + 'px';
        state.sendOrder.tableSet.height = (data -55) + 'px';
        state.sendOrder.entryTableSet.height = (data -55) + 'px';
    },
    ['clearData'](state, data) {
        state.sendOrder.tableSet.pagination.page = 1;
        state.sendOrder.tableSet.data = [];
        state.sendOrder.tableSet.selected = [];
        state.sendOrder.entryTableSet.data = [];
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState }, payload) {
        if (state.sendOrder.tableSet.loading == true) return
        let msg = { command: "inventory__list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        state.sendOrder.tableSet.loading = true
    },
    async ['return_inventory__list']({ state, commit }, payload) {
        state.sendOrder.tableSet.loading = false;
        if (payload.success) {
            commit('setList', payload.data)
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        state.sendOrder.tableSet.loading = true
        let msg = { command: "inventory__export", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
        state.sendOrder.tableSet.loading = false;
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
